import React from 'react';
import { NetlifyProps } from '../../types';
import Event from '../../components/Event';

const EventsPostPreview = ({ entry }: NetlifyProps) => {
  const data = entry.getIn(['data']).toJS();

  return (
    <Event
      title={data.title}
      description={data.description}
      location={data.location}
      date={new Date(data.date || Date.now())}
    />
  );
};

export default EventsPostPreview;
